module.exports = __webpack_public_path__ + "img/manage.c11cf57a.png";